module.exports = __webpack_public_path__ + "static/04-fafa3afd42cfda38084e0c44c449c361.jpg";